import { render, staticRenderFns } from "./规章制度.vue?vue&type=template&id=0b6b32f2&scoped=true"
import script from "./规章制度.vue?vue&type=script&lang=js"
export * from "./规章制度.vue?vue&type=script&lang=js"
import style0 from "./规章制度.vue?vue&type=style&index=0&id=0b6b32f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b32f2",
  null
  
)

export default component.exports